import React from 'react';
import {
  Card,
  styled
} from '@mui/material';

import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useLastSevenDaysOrderData } from '../../../requests/order';

const Title = styled('span')(() => ({
  fontSize: '1rem',
  fontWeight: '500',
  textTransform: 'capitalize',
}));

const OrderStatictics = () => {


  const { data: serverData } = useLastSevenDaysOrderData();


  return (
    <>

      <Card elevation={3} sx={{ pt: '20px', mb: 3 }} title='Last seven days order data'>
        <Title style={{ paddingLeft: 25 }}>Last seven days order data</Title>

        <div style={{ width: '100%', height: 280, marginTop: 20 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              width={500}
              height={250}
              data={serverData ?? []}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              {/* <CartesianGrid strokeDasharray="3 3" /> */}
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="delivered" fill="#fe5a1d" />
              <Bar dataKey="canceled" fill="#4caf50" />
              <Bar dataKey="total" fill="#8bc34a" />
            </BarChart>
          </ResponsiveContainer>
        </div>


      </Card>
    </>
  )
}

export default OrderStatictics